import { createApp } from 'vue';
import App from './App.vue';
import './assets/css/style.css'; // 导入全局样式

createApp(App).mount('#app');
